import { get } from 'lodash'
export default {
  data () {
    return {
    }
  },
  computed: {
    ecommerceSetup () {
      return get(this.$store.getters, 'getGeneralSettings.ecommerce_setup', {})
    },
    elegibilityMessage () {
      const elegibility = this.$store.getters.getElegibility

      let msgElegibility = null
      if (elegibility?.flowDiscount) {
        msgElegibility = []
        if (elegibility.resident !== '') {
          msgElegibility.push(
            {
              title: 'residents_flow_title',
              text: 'residents_flow_text'
            })
        }
        if (elegibility.numerousFamily === 'F1') {
          msgElegibility.push(
            {
              title: 'general_large_family_title',
              text: 'general_large_family_text'
            })
        }
        if (elegibility.numerousFamily === 'F2') {
          msgElegibility.push(
            {
              title: 'special_large_family_title',
              text: 'special_large_family_text'
            })
        }
      }
      return msgElegibility
    }
  },
  methods: {
  }
}
